import ActionNames from '../../actions/names';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: false,
  data: {},
  error: null
});

function SummaryDataForBrandAndLocale(state = initialState, action) {
  switch (action.type) {
    case ActionNames.REQUEST_LIGHTHOUSE_SUMMARY_DATA:
      return state.merge({ data: {}, loading: true });
    case ActionNames.RECEIVE_LIGHTHOUSE_SUMMARY_DATA:
      return state.merge({ data: action.data, loading: false });
    case ActionNames.ERROR_LIGHTHOUSE_SUMMARY_DATA:
      return state.merge({ error: action.error, loading: false });
    default:
      return state;
  }
}

export default SummaryDataForBrandAndLocale;
